import React, { Fragment } from "react";
import { useSearchParams } from "react-router-dom";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

import AdministrationHeader from "../../components/header-components/AdministrationHeader";
import ActivityLog from "./ActivityLog";
import PipelineTab from "./PipelineTab";
import ActivityPeriodSelector from "./ActivityPeriodSelector";

const DataImportsListPage = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") === "activity" ? "activity" : "pipeline";

  return (
    <Fragment>
      {/* The legacy date-range PeriodSelector is off for both tabs now. The activity tab
          gets ActivityPeriodSelector instead: the control /financial-control uses, living
          in the shared header's row 2 rather than a separate sub-toolbar. */}
      <AdministrationHeader
        title="Configuration"
        className="text-text-3"
        icon={icon({ name: "wrench", style: "light" })}
        showPeriodSelector={false}
      />
      {activeTab === "activity" && <ActivityPeriodSelector />}
      <div className="text-left flex flex-auto flex-col ml-10 mt-6 border-solid border-border">
        {activeTab === "pipeline" && <PipelineTab />}
        {activeTab === "activity" && <ActivityLog />}
      </div>
    </Fragment>
  );
};

export default DataImportsListPage;
